import { render, staticRenderFns } from "./AlertWin.vue?vue&type=template&id=4dccbdad&scoped=true"
import script from "./AlertWin.vue?vue&type=script&lang=js"
export * from "./AlertWin.vue?vue&type=script&lang=js"
import style0 from "./AlertWin.vue?vue&type=style&index=0&id=4dccbdad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dccbdad",
  null
  
)

export default component.exports